import { useMutation } from '@apollo/client/react';
import { CREATE_STRIPE_PORTAL_SESSION } from '../queries/CreateStripePortalSession';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

// Define the expected shape of the mutation result
type CreateStripePortalSessionResult = {
  createPortalSession?: {
    url: string;
  };
};

export function useCreateStripePortalSession() {
  const context: LoggerContextProps = {
    action: 'createStripePortalSession',
  };

  const [createStripePortalSession, { data, loading, error }] =
    useMutation<CreateStripePortalSessionResult>(CREATE_STRIPE_PORTAL_SESSION);

  const createPortalSession = async () => {
    try {
      const { data } = await createStripePortalSession();
      if (data?.createPortalSession?.url) {
        window.location.href = data.createPortalSession.url;
      }
    } catch (error) {
      handleError(error, context, 'Failed to create portal session.');
    }
  };

  return { createPortalSession, data, loading, error };
}
